import React from 'react';
import { useState, useEffect, useRef } from 'react';
import {useLocation} from 'react-router-dom';
import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import { useAddNewUserMutation, useGetUsersQuery } from '../features/users/usersApiSlice';
import { useGetdesignationsQuery } from '../features/designations/designationApiSlice';
import { useGetofficetypeQuery } from '../features/officetype/officetypeApiSlice';
import { useGetStoreOfficesQuery } from '../features/storeoffices/storeofficesApiSlice';
import { useGetdesignationsuffixQuery } from '../features/designationsuffix/designationSuffixApiSlice';
import { useGetofficesQuery } from '../features/offices/officesApiSlice';
import { useUpdateofficeMutation } from '../features/offices/officesApiSlice';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem} from '@mui/material';
import { useIsMount } from '../features/hooks/useIsMount';
import { useAddNewDraftUserMutation, useDeleteDraftUserMutation, useGetDraftUsersQuery, useUpdateDraftUserMutation } from '../features/draftusers/draftUsersApiSlice';
import jwtDecode from 'jwt-decode'
import {Buffer} from 'buffer';
import CryptoJS from 'crypto-js';
import TextField from '@mui/material/TextField';
import {HeadingWrap, Span, CommonButton } from '../Styles/CommonStyles';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';


const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const MOBILE_REGEX = /^[0]?[789]\d{9}$/;
const EMPID_REGEX= /^[0-9]+$/;
const LANDLINE_REGEX= /^[0]\d{10}$/;
const OFFICEADD_REGEX=/.$/;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};



const Adduser =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 20px;
`
const Adduserformcont = styled.div`
  display: flex;
  flex-wrap:wrap;
  margin:50px;
`

const LabelInputWrapper = styled.div`
    /* margin-bottom:25px; */
    flex:1 0 30%;
    display: ${(props) => props.disp};
    min-height: 80px;
`
const MainRolesWrapper = styled.div`
  display: flex;
`
const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:10px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;

  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #5C5891;  
`

const Label = styled.label`
    width: 50px;
`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`

const flatten = (source, list) => {
    if (list === undefined) {
      list = []
    }
    for (const objs of (source || [])) {
      let { sub, ...item } = objs
      list.push(item)
      flatten(sub, list)
    }
    return list
  }

const childNames= (source, supoff, newarr) =>{ 
    if (newarr === undefined) {
        newarr = []
      }    
    for (const objs of (source || [])) {   
       if (objs.name === supoff) {
        if(objs.sub){
          for (const objs2 of objs.sub){
            let tempObj={};
            tempObj={"name":objs2.name, "type":objs2.type}
            newarr.push(tempObj);
          }
          break;
        }
        } else {
          childNames(objs.sub, supoff, newarr);
        }
      }
      return newarr;
    }
 
    const algorithm = 'aes-256-cbc';     
    const KEY = process.env.REACT_APP_ENC_KEY;

     

    const decrypt = (text, ivlink) => {
      let iv = Buffer.from(ivlink, 'hex');
      console.log(KEY, iv)
      let encryptedText = Buffer.from(text, 'hex');
      let decipher = crypto.createDecipheriv('aes-256-cbc', KEY, iv);
      let decrypted = decipher.update(encryptedText);
      decrypted = Buffer.concat([decrypted, decipher.final()]);
      return decrypted.toString();
   }

   const fetchLabel = (index, value, officedata) => {
    let fetchLableArray = [];  
    if(value[`level${index}`].length){
      fetchLableArray = officedata? Object.values(officedata)?.find(x=> x.name === value[`level${index}`])?.type:[]
    } else {
      let tempFetchLableArray = officedata? Object.values(officedata)?.filter((i,k)=>i.superioroffice === value[`level${index-1}`])?.map((item,index) => item.type):[];
      console.log(tempFetchLableArray)
      //Removing duplicate entries.
      fetchLableArray = tempFetchLableArray.filter((item, index) => tempFetchLableArray.indexOf(item) === index)?.map((item,index) => index === 0? item:`/${item}`)
    }
    return fetchLableArray
   }

const Signup = () =>{

    const [updateDraftUser] = useUpdateDraftUserMutation();
    const {draftuserdata} = useGetDraftUsersQuery("draftusersList", {
      selectFromResult: ({ data }) => ({
        draftuserdata: data?.entities
      }),
    })
    console.log()    

    const userRef = useRef();
    const count = useRef(0);
    const isMount = useIsMount();
    const errRef = useRef();
    const token = new URLSearchParams(useLocation().search).get("token");
    // In the URL by default the "+ sign converts to space so we convert it back"
    const newstring = token.split(' ').join('+');

    const bytes  = CryptoJS.AES.decrypt(newstring, "CiDzdsoM4OE8AEOqp7A3ROrHuEVP6ctH").toString(CryptoJS.enc.Utf8);
    const originaltoken = JSON.parse(bytes)

    console.log(originaltoken)
    const decoded = jwtDecode(originaltoken.verifyingToken)
    console.log(Date.now())

    console.log(decoded)

    const initialUserState = {
      id:"",
      name:{firstName:"", middleName:"", lastName:""},
      email:"",
      password: "",
      mobileNo:"",
      officeLandLine:"",
      employeeID: "",
      officeAddress:"",
      office: {mainCharge:"", additionalCharge:[]},
      designation:{},
      designationSuffix:{},
      numSuffix:{},
      roles:{main:["user"]},
      assets:{},
      indi_assets:[],
      bo_assets:{},
      store_assets:{},
      active:true,
      submissionDate: new Date(Date.now()).toISOString(), 
      reqType: "signupreq"
  }
  
  const initialValueState = {
    firstname:"",
    middlename:"",
    lastname:"",
    email:"",
    password:"",
    confirmpassword:"",
    designation:"",
    designationsuffix:"",
    mobilenumber:"",
    landlinenumber:"",
    employeeid:"",
    officeaddress:"",
    level0:"",
    level1:"",
    level2:"",
    level3:"",
    level4:"",
    level5:"",
    store:"",
    roles:[]        
}
    const [subdispl, setSubdispl] = useState("none");
    const [presentOffType, setPresentOffType] = useState();
    const [officeType, setOfficeType] = useState([]);
    const [reportingOfficer, setReportingOfficer] = useState();
    const [desigSuffix, setDesigSuffix] = useState([]);
    const [offices, setOffices] = useState([]);
    const [renderFields, setRenderFields] = useState([]);
    const [userData, setUserData] = useState([]);
    const [users, setUsers] = useState(initialUserState);
    const [value, setValue] = useState(initialValueState)
    const [desig, setDesig] = useState([])
    const [displ, setDispl] = useState({
        level1:"block",
        level2:"none",
        level3:"none",
        level4:"none",
        level5:"none",
    })
    const otherRoles = [
      'assetManager',
      'assetApprover'
    ]

    const [validFirstName, setValidFirstName] = useState(false);
    const [firstNameFocus, setFirstNameFocus] = useState(false);

    const [validMiddleName, setValidMiddleName] = useState(false);
    const [middleNameFocus, setMiddleNameFocus] = useState(false);

    const [validLastName, setValidLastName] = useState(false);
    const [lastNameFocus, setLastNameFocus] = useState(false);

    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);

    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [validMobile, setValidMobile] = useState(false);
    const [mobileFocus, setMobileFocus] = useState(false);

    const [validEmpId, setValidEmpId] = useState(false);
    const [empIDFocus, setEmpIDFocus] = useState(false);

    const [validLandline, setValidLandline] = useState(false);
    const [landlineFocus, setLandlineFocus] = useState(false);

    const [validOfficeAdd, setValidOfficeAdd] = useState(false);
    const [officeAddFocus, setOfficeAddFocus] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);


    useEffect(() => {
      count.current = count.current + 1;
    });

    useEffect(() => {
      if(decoded.exp > Date.now()/1000){
        userRef?.current?.focus();
      }
    }, [])

    useEffect(() => {
        setValidFirstName(USER_REGEX.test(users.name.firstName));
        setValidMiddleName(USER_REGEX.test(users.name.middleName));
        setValidLastName(USER_REGEX.test(users.name.lastName));
    }, [users.name.firstName, users.name.middleName, users.name.lastName ])



    useEffect(() => {
        setValidPwd(PWD_REGEX.test(users.password));
        setValidMatch(users.password === value.confirmpassword);
    }, [users.password, value.confirmpassword])

    useEffect(() => {
        setValidMobile(MOBILE_REGEX.test(users.mobileNo));        
    }, [users.mobileNo])

    useEffect(() => {
        setValidEmpId(EMPID_REGEX.test(users.employeeID));        
    }, [users.employeeID])

    useEffect(() => {
        setValidLandline(LANDLINE_REGEX.test(users.officeLandLine));        
    }, [users.officeLandLine])

    useEffect(() => {
        setValidOfficeAdd(OFFICEADD_REGEX.test(users.officeAddress));        
    }, [users.officeAddress])

    // console.log(count)
    
    const onChangeuserform = (event, newValue, name) => {
      console.log(name, newValue)

      let tempUser = structuredClone(users);
      let tempValue ={...value}
      if(["firstName", "middleName", "lastName"].includes(event.target.name)){
        tempUser.name[event.target.name] = event.target.value;
      }
      if(["email","password","mobileNo","officeLandLine", "employeeID","officeAddress"].includes(event.target.name)){
        tempUser = {...tempUser, [event.target.name]:event.target.value}
      }
      if(event.target.name === "confirmpassword"){
        tempValue = {...tempValue, [event.target.name]:event.target.value }
      }

      if(name?.includes("level") && newValue !== null){
        tempUser.office.mainCharge = newValue;
        setPresentOffType(offices.find(x => x.name === newValue).type)
        tempValue = {...tempValue, [name]:newValue}
        //Change type of office in label based on the office chosen.
        let tempRender = [];
        for(let i=0; i<6; i++){
          if(tempValue[`level${i}`].length){
            tempRender.push(tempValue[`level${i}`])
          }else{
            break;
          }
        }
        setRenderFields(tempRender);
        }

      if(name?.includes("level") && newValue === null){
          const levelIndex = name.charAt(name.length-1);
          tempUser.office.mainCharge = value[`level${levelIndex-1}`];
          setPresentOffType(offices.find(x => x.name === value[`level${levelIndex-1}`]).type)
          for(let i=levelIndex; i<7; i++){
              tempValue[`level${i}`] = "";
          }
          //Change type of office in label based on the office chosen.
          let tempRender = [];
          for(let i=0; i<6; i++){
            if(tempValue[`level${i}`].length){
              tempRender.push(tempValue[`level${i}`])
            }else{
              break;
            }
          }
          setRenderFields(tempRender);
        }

      if(name === "designation"){
        tempUser.designation[tempUser.office.mainCharge] = newValue;        
      }
      if(name === "designationSuffix"){
        tempUser.designationSuffix[tempUser.office.mainCharge] = newValue;        
      }
      setUsers(tempUser)
      setValue(tempValue)                      
    }  

    let id = offices?.find(x => x.name ===  users.office.mainCharge)?._id
    let officeBody = {"id":id};
    console.log(userData)

    //Check this filter
    const sameOfficeUsers = Object.values(userData)?.filter(x => (x.office.mainCharge ===  users.office.mainCharge) || (x.office.additionalCharge.includes( users.office.mainCharge)))
    const sameOfficeDesgnUsers = sameOfficeUsers?.filter(x => Object.values(x.designation).includes(users.designation[users.office.mainCharge]))

    //Sort users having same office and designation in order of numIndex using Quick Sort Algorithm.

    const sortedSameOfficeDesgnUsers = sameOfficeDesgnUsers.sort((a,b) => (a.numSuffix[presentOffType] > b.numSuffix[presentOffType]) ? 1 : ((b.numSuffix[presentOffType] > a.numSuffix[presentOffType]) ? -1 : 0))
    // console.log(sortedSameOfficeDesgnUsers)
    

    const onClickConfirm = () => {
        setSubdispl("block");   
        let tempUsers = structuredClone(users);
        if(Object.values(userData).map(x => x.mobileNo).includes(tempUsers.mobileNo)){
          return alert("Mobile Number Already Exists. Please use different mobile number")
        }
        if(Object.values(userData).map(x => x.email).includes(tempUsers.email)){
          return alert("Email ID Already Exists. Please use different Email")
        }
        if(Object.values(userData).map(x => x.employeeID).includes(tempUsers.employeeID)){
          return alert("Employee ID Already Exists. Please use unique Employee ID")
        }
        if(!sortedSameOfficeDesgnUsers?.length){
          tempUsers.numSuffix[ users.office.mainCharge] = 1;
        }
        for(let i = 1; i < (sortedSameOfficeDesgnUsers?.length + 1); i++){
          if(sortedSameOfficeDesgnUsers[i-1]?.numSuffix[ users?.office?.mainCharge] !== (sortedSameOfficeDesgnUsers[i]?.numSuffix[ users?.office?.mainCharge]-1)){
            tempUsers.numSuffix[ users.office.mainCharge] = i+1;
            break;
          }           
        }
        tempUsers.roles = {...tempUsers.roles, [ users.office.mainCharge]:[]};
        console.log(officeType?.find(x=> x.type=== presentOffType)?.unitHead?.includes(users.designation[users.office.mainCharge]))
        console.log(officeType?.find(x=> x.type=== presentOffType)?.unitHead)
        console.log(users.designation[users.office.mainCharge])
        if(( users.office.mainCharge === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType)?.UnitHead?.includes(users?.designation[users.office.mainCharge]))){
          console.log("first")
          tempUsers.roles[ users.office.mainCharge].push("UnitHead");
          setReportingOfficer("Not Applicable");
        }else{
          if(officeType?.find(x=> x.type=== presentOffType)?.unitHead?.includes(users.designation[users.office.mainCharge])){
            console.log("second")
            tempUsers.roles[ users.office.mainCharge].push("UnitHead")
            let supOffice = offices?.find(x => x.name ===  users.office.mainCharge).superioroffice;
            let repoOfficer = offices?.find(a => a.name === supOffice).unitHead;
            if(repoOfficer?.length) {
              console.log("third")
              setReportingOfficer(repoOfficer);
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("fourth")}
          } else {
            console.log("fifth")
            console.log(offices?.find(x => x.name ===  users.office.mainCharge))
            if(offices?.find(x => x.name ===  users.office.mainCharge)?.unitHead?.length){
            console.log("sixth")
            setReportingOfficer(offices.find(x => x.name ===  users.office.mainCharge).unitHead)
            }else{setSubdispl("none"); alert("Reporting Officer not Registered"); console.log("Seventh")}
          }
      }    

      if(( users.office.mainCharge === offices?.find(x => x.level === "level1").name) && (officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[users.office.mainCharge]))){
        alert("You are creating Top level user. Reporting officer is Not Applicable."); 

      }else{
        alert("Please check your reporting officer before final submission");
      }       
      setUsers(tempUsers);
    }
    console.log(presentOffType)
    console.log(users)
    
    const onClickFormSubmit = async (e) =>{
      console.log("Entered Form Submit")
        e.preventDefault();
        // if button enabled with JS hack
        const v1 = EMAIL_REGEX.test(users.email)
        const v2 = PWD_REGEX.test(users.password);
        console.log(v1,v2)
        if (!v1 || !v2) {
              setErrMsg("Invalid Entry");
              return;
        }
        try{     
        const body ={...users, "status":"signup_submitted"}
        //Check if the present office type includes the present designation for unit head. 
        if(officeType.find(x=> x.type=== presentOffType).unitHead.includes(users.designation[users.office.mainCharge])){
          if(offices?.find(x => x.name ===  users.office.mainCharge)?.unitHead?.length){
            alert("Unit Head already posted");
            return
          }
        const res = await updateDraftUser(body);
        console.log(res)
        // The user will be added in draft user at this stage. During approval the unithead key will be updated in office document.         
        }else {
          console.log("else")
          const res = await updateDraftUser(body);
        }
        alert(`You have successfully Registered.  Name: ${users.name.firstName} ${users.name.middleName} ${users.name.lastName}, Email:${users.email}, Office:${users.office.mainCharge}, Designation:${users.designation[users.office.mainCharge]} Your Account will be active after approval from reporting officer.`)
        
        let tempUser = structuredClone(initialUserState);
        let tempValue = structuredClone(initialValueState);
        tempValue.level0 = offices[0].name
        tempUser.office.mainCharge = Object.values(offices).find( x => x.level === "level1").name
        setUsers(tempUser);
        setValue(tempValue);
        setSubdispl('none')
        setPresentOffType(Object.values(offices).find( x => x.level === "level1")?.type)
        } catch(err){
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Registration Failed')
            }
            // errRef.current.focus();
        }
    }
    console.log(reportingOfficer)  


    // console.log(validFirstName,validMiddleName, validLastName, validEmail, validPwd, validMatch, validMobile,validEmpId, validLandline, validOfficeAdd)

    // console.log(firstNameFocus, middleNameFocus, lastNameFocus, emailFocus, empIDFocus, pwdFocus, matchFocus, mobileFocus, officeAddFocus)


  const {officedata} = useGetofficesQuery("officeList", {
    selectFromResult: ({ data }) => ({
      officedata: data?.entities
    }),
  })

  const {officetype} = useGetofficetypeQuery("officeTypeList", {
    selectFromResult: ({ data }) => ({
      officetype: data?.entities
    }),
  })

  const {designationsuffix}= useGetdesignationsuffixQuery("desigsuffix", {
    selectFromResult: ({ data }) => ({
      designationsuffix: data?.entities
    }),
  })
  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })

  const {designation} = useGetdesignationsQuery("designations", {
    selectFromResult: ({ data }) => ({
        designation: data?.entities
      }),
  })

  const {userdata} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
      userdata: data?.entities
    }),
  })


  useEffect(()=>{
    if(officedata ){
      console.log("Entered if Officedata")
        const finalOfficeData = Object.values(officedata)
        setOffices(finalOfficeData)
        //On first time render the renderArray is being prepared. The if function used here is to enusre that the renderArray is not prepared again on subsequent renders.
        if(!users.office.mainCharge.length){
          console.log("Entered first render")
        let renderArray = [];
        renderArray.push(finalOfficeData.find( x => x.level === "level1").name)
        setRenderFields(renderArray)
        let tempUser = structuredClone(users)
        tempUser.office.mainCharge = finalOfficeData.find( x => x.level === "level1").name;
        tempUser.id =  decoded.UserInfo.id;
        tempUser.email = decoded.UserInfo.email;
        setPresentOffType(finalOfficeData.find( x => x.level === "level1")?.type)
        let tempVal={...value}
        tempVal.level0 = finalOfficeData.find( x => x.level === "level1").name;
        setValue(tempVal);
        setUsers(tempUser)
      }
    }
  },[officedata])

console.log(renderFields)

  useEffect(()=>{
    if(officetype){
        setOfficeType(Object.values(officetype))
    }
  },[officetype])


  useEffect(()=>{
    if(designationsuffix){
        setDesigSuffix(Object.values(designationsuffix))
    }
  },[designationsuffix])

  useEffect(()=>{
    if(designation){
        setDesig(Object.values(designation))
    }
  },[designation])

  useEffect(()=>{
    if(userdata){
      setUserData(userdata)
    }
  },[userdata])
  // console.log(Object.values(officedata).find)

  // console.log(draftuserdata && Object.values(draftuserdata)?.find(x => x.email === decoded.UserInfo.email).status === "signup_requested")
const testValue = true;
    return (
      // (decoded.exp < Date.now()/1000)? <div>Link has expired. Please resubmit.</div>:
      // (draftuserdata && Object.values(draftuserdata)?.find(x => x.email === decoded.UserInfo.email).status !== "signup_requested")
      (draftuserdata && Object.values(draftuserdata)?.find(x => x.email === decoded.UserInfo.email)?.status === "signup_requested")?
         <>
        <Adduser>
            <div>Register as New User</div>      
        </Adduser>

        <form onSubmit={(e)=>onClickFormSubmit(e)}>
        
        <Adduserformcont>
            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='firstName'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="First Name"
                  value={users.name.firstName}
                  variant="outlined"
                  onFocus={() => setFirstNameFocus(true)}
                  onBlur={() => setFirstNameFocus(false)}
                  // sx={{width:"100%"}}
                />      
                { firstNameFocus && !validFirstName ? <div>Please Enter Valid First Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='middleName'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Middle Name"
                  value={users.name.middleName}
                  variant="outlined"
                  onFocus={() => setMiddleNameFocus(true)}
                  onBlur={() => setMiddleNameFocus(false)}
                  // sx={{width:"100%"}}
                />    
                {middleNameFocus && !validMiddleName ? <div>Please Enter Valid Middle Name</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='lastName'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Last Name"
                  value={users.name.lastName}
                  variant="outlined"
                  onFocus={() => setLastNameFocus(true)}
                  onBlur={() => setLastNameFocus(false)}
                  // sx={{width:"100%"}}
                />
                {lastNameFocus && !validLastName ? <div>Please Enter Valid Last Name</div>:null}
            </LabelInputWrapper>          

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='password'
                  type='password'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Password"
                  value={users.password}
                  variant="outlined"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                  // sx={{width:"100%"}}
                />               
                {pwdFocus && !validPwd ?<div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='confirmpassword'
                  type='password'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Confirm Password"
                  value={value.confirmpassword}
                  variant="outlined"
                  onFocus={() => setMatchFocus(true)}
                  onBlur={() => setMatchFocus(false)}
                  // sx={{width:"100%"}}
                />
                {matchFocus && !validMatch? <div>Password Error Message</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='mobileNo'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Mobile Number"
                  value={users.mobileNo}
                  variant="outlined"
                  onFocus={() => setMobileFocus(true)}
                  onBlur={() => setMobileFocus(false)}
                  // sx={{width:"100%"}}
                />             
                {mobileFocus && !validMobile ? <div>Enter Valid Mobile Number</div>: null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='employeeID'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Employee ID"
                  value={users.employeeID}
                  variant="outlined"
                  onFocus={() => setEmpIDFocus(true)}
                  onBlur={() => setEmpIDFocus(false)}
                  // sx={{width:"100%"}}
                /> 
                {empIDFocus && !validEmpId ? <div>Enter Valid Employee ID</div>: null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='officeLandLine'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Office Landline"
                  value={users.officeLandLine}
                  variant="outlined"
                  onFocus={() => setLandlineFocus(true)}
                  onBlur={() => setLandlineFocus(false)}
                  // sx={{width:"100%"}}
                />
                {landlineFocus && !validLandline ? <div>Enter Valid Landline Number</div>:null}
            </LabelInputWrapper>

            <LabelInputWrapper>
                <TextField
                  id="outlined-basic"
                  size='small'
                  ref={userRef}
                  name='officeAddress'
                  type='text'
                  onChange={(event, newValue) => onChangeuserform(event, newValue)}
                  label="Enter Office Address"
                  value={users.officeAddress}
                  variant="outlined"
                  onFocus={() => setOfficeAddFocus(true)}
                  onBlur={() => setOfficeAddFocus(false)}
                  // sx={{width:"100%"}}
                />                
                {officeAddFocus && !validOfficeAdd ? <div>Enter Valid Office Address</div>: null}
            </LabelInputWrapper>              
            {console.log(renderFields)}
           {renderFields.concat([""]).map((item,index)=>{
                return (
            <LabelInputWrapper key={index} disp={displ.level1}>
               <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  size='small'
                  value={value[`level${index}`]}
                  onChange={(event, newValue) => onChangeuserform(event, newValue, `level${index}`)}
                  options={offices.filter((i,k)=>i.superioroffice === value[`level${index-1}`])
                  ?.map((item,index) => item.name)}
                  sx={{ width: "50%" }}
                  //In label the field is fetched dynamically. If no field is selected it gives all office types separated by "/". As soon as we select the office the corresponding office typw shows in the label.
                  renderInput={(params) => <TextField {...params} label={offices.filter((i,k)=>i.superioroffice === value[`level${index-1}`])?.map((item,index) => item.name).length? fetchLabel(index, value, officedata):"No Options"} />}
                  // Object.values(userData).find(x=> x.name ) value[`level${index}`]
                />
              </LabelInputWrapper>
                )
            })}
{/* officeTypeLabels[item.level]?.map((item,index) => index === 0? item:`/${item}`) */}
                  <LabelInputWrapper>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        size='small'
                        value={users?.designation[users?.office?.mainCharge]?.length? users?.designation[users?.office?.mainCharge]:"" }
                        onChange={(event, newValue) => onChangeuserform(event, newValue, "designation")}
                        options={desig?.map((item)=>item.name)}
                        sx={{ width: "50%" }}
                        renderInput={(params) => <TextField {...params} label={"Enter Designation"} />}
                      /> 
                </LabelInputWrapper>

                <LabelInputWrapper>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        size='small'
                        value={users?.designationSuffix[users?.office?.mainCharge]?.length? users?.designationSuffix[users?.office?.mainCharge]:"" }
                        onChange={(event, newValue) => onChangeuserform(event, newValue, "designationSuffix")}
                        options={desigSuffix?.map((item)=>item.name)}
                        sx={{ width: "50%" }}
                        renderInput={(params) => <TextField {...params} label={"Enter Designation Suffix"} />}
                      /> 
                </LabelInputWrapper>     
        </Adduserformcont>
        <SubmitButton type='button' disabled={!validFirstName || !validMiddleName || !validLastName || !validEmpId || !validLandline || !validPwd || !validMatch || !validMobile || !validOfficeAdd || !users?.designation[users?.office?.mainCharge]?.length ? true: false} onClick={(e)=>onClickConfirm(e)}>Confirm</SubmitButton>      
        <div style={{display:subdispl}}>
          <SubHeadingField>
              Reporting Officer:
          </SubHeadingField>
            <TextField
              id="outlined-basic"
              size='small'
              name='reportingofficer'
              type='text'
              value = {reportingOfficer === "Not Applicable"? reportingOfficer:`${userData[reportingOfficer]?.name?.firstName} ${userData[reportingOfficer]?.name?.middleName} ${userData[reportingOfficer]?.name?.lastName} (${userData[reportingOfficer]?.designation[userData[reportingOfficer]?.office?.mainCharge]})`}
              variant="outlined"
              sx={{backgroundColor:"lightblue", width:"25%"}}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
              readOnly
              /> 


                <Label>Reporting Officer</Label>
                <input
                type="text"
                required="required"
                // The name of Reporting officer should come from users data base dynamically.
                value={reportingOfficer === "Not Applicable"? reportingOfficer:`${userData[reportingOfficer]?.name?.firstName} ${userData[reportingOfficer]?.name?.middleName} ${userData[reportingOfficer]?.name?.lastName} (${userData[reportingOfficer]?.designation[userData[reportingOfficer]?.office?.mainCharge]})`} 
                name="reportingofficer"
                readOnly
                ></input>
        </div>
          <SubmitButton type='submit' style={{display:subdispl}}>Submit</SubmitButton>        
        </form>
      
        </>:
        <div>Your Request has been submitted successfully. Please Contact your Reporting Officer or Admin</div>
      )
}
export default Signup;

